<template>
  <div style="width: 100%; height: 100%; display: flex">
    <div class="left">
      <div
        style="
          font-size: 14px;
          color: #838892;
          line-height: 16px;
          padding: 15px 20px;
        "
      >
        部门
      </div>
      <div style="overflow: auto; padding: 15px">
        <el-tree
          :props="defaultProps"
          :load="loadNode"
          lazy
          @node-click="handleNodeClick"
        ></el-tree>
      </div>
    </div>
    <div class="right">
      <div style="display: flex; justify-content: flex-end; align-items: center">
        <el-input
          v-model="search"
          @change="handleSearch"
          placeholder="请输入姓名"
          style="width: 200px;  height: 32px"
          clearable
          prefix-icon="el-icon-search"
        ></el-input>
        <!-- <el-button type="primary" size="mini" style="height: 32px; width: 80px">
          <svg-icon
            icon-class="icon_export"
            style="font-size: 14px; vertical-align: bottom"
          ></svg-icon>
          导出</el-button
        > -->
      </div>
      <el-table
        :data="userData"
        style="width: 100%; margin-top: 14px"
        :header-cell-style="headerCellStyle"
        height="100%"
      >
        <el-table-column prop="name" label="姓名" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="电话" align="center">
        </el-table-column>
        <el-table-column prop="deptName" label="所属部门" align="center">
        </el-table-column>
        <el-table-column prop="roleName" label="角色" align="center">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getOrgTree, getUserByName } from "@/api/org.js";
import { headerCellStyle } from "@/utils/CustomUtil.js";
export default {
  name: "CmsAdmin",
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
      nowDeptId: null,
      userData: [],
      search: "",
      activeDept: null,
      loading: false,
    };
  },
  methods: {
    headerCellStyle,
    async handleSearch(name) {
      if (name) {
        const { data } = await getUserByName({ name });
        this.userData = data;
      } else {
        this.handleNodeClick(this.activeDept);
      }
    },
    async loadNode(node, resolve) {
      this.loading = true;
      if (node.level === 0) {
        const res = await getOrgTree({
          deptId: 1,
          type: "user",
        });
        this.loading = false;
        return resolve(res.data);
      } else {
        const res = await getOrgTree({
          deptId: node.data.id,
          type: "user",
        });
        const dept = res.data.filter((item) => item.type === "dept");
        this.userData = res.data.filter((item) => item.type === "user");
        this.loading = false;
        return resolve(dept);
      }
    },
    async handleNodeClick(data) {
      this.activeDept = { ...data };
      if (this.loading) return;
      const res = await getOrgTree({
        deptId: this.activeDept.id,
        type: "user",
      });
      this.userData = res.data.filter((item) => item.type === "user");
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.left {
  border-right: 1px solid #ebecee;
  width: 264px;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.right {
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

::v-deep .el-tree-node__content {
  height: 36px;
  border-radius: 4px;
}

::v-deep .el-input__inner {
  height: 32px;
}

::v-deep .el-input__icon {
  line-height: 32px;
}
</style>